var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFinancialSupportLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5953 35.31C36.5953 36.88 35.3153 38.15 33.7553 38.15H25.4153C23.8053 38.15 22.2453 37.57 21.0253 36.53L15.7553 32.04H12.9753V22.54H21.8353C22.5553 22.54 23.2753 22.8 23.8253 23.27L28.5453 27.28C29.2253 27.86 29.5753 28.68 29.5753 29.52C29.5753 30.2 29.3453 30.87 28.8753 31.42C28.4353 31.95 27.8453 32.28 27.2153 32.42L26.5253 32.48H33.7553C34.5453 32.48 35.2453 32.8 35.7553 33.3C36.2753 33.82 36.5953 34.53 36.5953 35.32V35.31Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7853 30.0901L24.7353 31.7501C25.4453 32.3501 26.3553 32.5601 27.2153 32.4001",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9853 22.54V32.04H8.87527C8.06527 32.04 7.40527 31.38 7.40527 30.57V24.02C7.40527 23.21 8.06527 22.55 8.87527 22.55H12.9853V22.54Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2549 18.9198C19.2549 13.7498 23.4449 9.5498 28.6249 9.5498C33.8049 9.5498 37.9949 13.7398 37.9949 18.9198C37.9949 22.6298 35.8349 25.8398 32.7049 27.3598",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2348 17.4202H29.2048C28.5048 17.2302 27.9448 17.0902 27.9448 16.6702C27.9448 16.3502 28.3048 16.2002 28.6648 16.2002C29.0248 16.2002 29.4348 16.3702 29.4348 16.8402H31.5348C31.5348 15.6302 30.8348 14.7802 29.6148 14.5102L29.5448 14.4902V13.7402H27.8448V14.4802L27.7648 14.5002C26.5148 14.7502 25.8048 15.5702 25.8048 16.7302C25.8048 18.4402 27.1848 18.7802 28.2948 19.0602H28.3248C29.0248 19.2402 29.5748 19.3802 29.5748 19.8302C29.5748 20.2202 29.1448 20.4302 28.7348 20.4302C28.3048 20.4302 27.8648 20.2002 27.8648 19.6802H25.6948C25.6948 20.9702 26.4948 21.9102 27.8348 22.1802L27.9048 22.2002V22.9802H29.6048V22.1902L29.6748 22.1702C30.9948 21.8902 31.7548 21.0202 31.7548 19.7802C31.7548 18.0602 30.2848 17.6802 29.2048 17.4002L29.2348 17.4202Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinancialSupportLight);
export default __webpack_public_path__ + "static/media/icon_financial_support_light.6a5c723a.svg";
export { ForwardRef as ReactComponent };